import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "features"
    }}>{`Features`}</h1>
    <ul>
      <li parentName="ul">{`Automatically attach invoice PDF to WooCommerce emails of your choice`}</li>
      <li parentName="ul">{`Download the PDF invoice from the admin order listing page`}</li>
      <li parentName="ul">{`Download the PDF invoice from the admin order details page`}</li>
      <li parentName="ul">{`Download the PDF invoice from cart & checkout page`}</li>
      <li parentName="ul">{`Download invoices from the My Account order listing page`}</li>
      <li parentName="ul">{`Download invoices from the My Account order details page`}</li>
      <li parentName="ul">{`Sequential invoice numbers- Setting panel`}</li>
      <li parentName="ul">{`Insert customer header image/logo`}</li>
      <li parentName="ul">{`Modify shop data / footer / disclaimer etc. on the invoices.`}</li>
      <li parentName="ul">{`Select paper size (Portrait or A4)`}</li>
      <li parentName="ul">{`Translation Ready`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      